import React from 'react';
import { Route, Routes } from 'react-router-dom';
import MainLayout from './MainLayout';
import { KeyWordVer1 } from '../../pages/KeyWordVer1/KeyWordVer1';
import { KeyWordVer2 } from '../../pages/KeyWordVer2/KeyWordVer2';
import { FindMid } from '../../pages/FindMid/FindMid';
import { FindNaverRank } from '../../pages/FindNaverRank/FindNaverRank';
import { FindNaverRankTracking } from '../../pages/FindNaverRankTracking/FindNaverRankTracking';
import { Login } from '../../pages/Login/Login';
import ProtectedRoute from '../ProtectedRoute';
import HomeRedirect from '../HomeRedirect';
import Intro from '../../pages/Intro/Intro';
import { NaverIntegratedRank } from '../../pages/NaverIntegratedRank';
import { FindProductByMid } from '../../pages/FindProductByMid';
import { ChangeUrl } from '../../pages/ChangeUrl/ChangeUrl';
import { CountText } from '../../pages/CountText';
import { KeywordRankVolumeCheck } from '../../pages/KeywordRankVolumeCheck';
import IntegratedSearch from '../../pages/IntegratedSearch';
import ProductAnalysis from '../../pages/ProductAnalysis/ProductAnalysis';
import RankHistoryWatch from '../../pages/RankHistoryWatch/RankHistoryWatch';
import AutoComplete from '../../pages/AutoComplete/AutoComplete';
import ProductGenerate from '../../pages/ProductGenerate/ProductGenerate';
import KakaoCallback from '../../pages/Login/KakaoCallback';
import { DashBoard } from '../../pages/DashBoard/DashBoard';
import { GradeGuide } from '../../pages/GradeGuide/GradeGuide';
import { PaymentSuccess } from '../../pages/Payment/PaymentSuccess';
import { PaymentFail } from '../../pages/Payment/PaymentFail';
import PaymentHistory from '../../pages/Payment/PaymentHistory';
import { SlotGuide } from '../../pages/SlotGuide/SlotGuide';

const Layout = () => {
    return (
        <Routes>
            {/* 공개 페이지 (인증 불필요) */}
            <Route path="/login" element={<Login />} />
            <Route path="/auth/kakao/callback" element={<KakaoCallback />} />
            <Route path="/intro" element={<Intro />} />

            {/* 보호된 라우트들은 MainLayout 내부에서 렌더링 */}
            <Route
                element={
                    <ProtectedRoute>
                        <MainLayout />
                    </ProtectedRoute>
                }
            >
                <Route path="/" element={<HomeRedirect />} />
                <Route path="/keywordVer1" element={<KeyWordVer1 />} />
                <Route path="/keywordVer2" element={<KeyWordVer2 />} />
                <Route path="/NaverIntegratedRank" element={<NaverIntegratedRank />} />
                <Route path="/findMid" element={<FindMid />} />
                <Route path="/findProductByMid" element={<FindProductByMid />} />
                <Route path="/findNaverRank" element={<FindNaverRank />} />
                <Route path="/findNaverRankTracking" element={<FindNaverRankTracking />} />
                <Route path="/changeUrl" element={<ChangeUrl />} />
                <Route path="/countText" element={<CountText />} />
                <Route path="/dashboard" element={<DashBoard />} />
                <Route path="/main" element={<HomeRedirect />} />
                <Route path="/NaverSaleAnalysis" element={<HomeRedirect />} />
                <Route path="/NaverIndexAnalysis" element={<HomeRedirect />} />
                <Route path="/KeywordRankVolumeCheck" element={<KeywordRankVolumeCheck />} />
                <Route path="/integratedSearch" element={<IntegratedSearch />} />
                <Route path="/product-analysis" element={<ProductAnalysis />} />
                <Route path="/rankHistoryWatch" element={<RankHistoryWatch />} />
                <Route path="/autoComplete" element={<AutoComplete />} />
                <Route path="/productGenerate" element={<ProductGenerate />} />
                <Route path="/grade-guide" element={<GradeGuide />} />
                <Route path="/payment/history" element={<PaymentHistory />} />
                <Route path="/payment/success" element={<PaymentSuccess />} />
                <Route path="/payment/fail" element={<PaymentFail />} />
                <Route path="/slot-guide" element={<SlotGuide />} />
            </Route>
        </Routes>
    );
};

export default Layout;
